"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RegistrationDraftsContentHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, "Registration Drafts contains the saved information from incomplete work registrations."),
    react_1.default.createElement("p", null, "PLEASE NOTE: A draft can only be saved once."),
    react_1.default.createElement("p", null, "Drafts will be saved here for up to three months from the original saved date.")));
exports.default = RegistrationDraftsContentHeader;
